var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoTagsFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 171,
    viewBox: "0 0 142 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 652",
    d: "M71 159.501C110.212 159.501 142 127.713 142 88.5012C142 49.289 110.212 17.5012 71 17.5012C31.7878 17.5012 0 49.289 0 88.5012C0 127.713 31.7878 159.501 71 159.501Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    filter: "url(#filter0_d_19611_26762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5615",
    d: "M30.2939 58.7065H111.707C114.045 58.7065 115.941 60.6019 115.941 62.9399V162.34C115.941 164.678 114.045 166.573 111.707 166.573H30.2939C27.9559 166.573 26.0605 164.678 26.0605 162.34V62.9399C26.0605 60.6019 27.9559 58.7065 30.2939 58.7065Z",
    fill: "white",
    stroke: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5617",
    d: "M61.5354 72.4072H36.922C35.3535 72.4072 34.082 73.6787 34.082 75.2472C34.082 76.8157 35.3535 78.0872 36.922 78.0872H61.5354C63.1039 78.0872 64.3754 76.8157 64.3754 75.2472C64.3754 73.6787 63.1039 72.4072 61.5354 72.4072Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5618",
    d: "M78.5754 84.7158H36.922C35.3535 84.7158 34.082 85.9873 34.082 87.5558C34.082 89.1243 35.3535 90.3958 36.922 90.3958H78.5754C80.1439 90.3958 81.4154 89.1243 81.4154 87.5558C81.4154 85.9873 80.1439 84.7158 78.5754 84.7158Z",
    fill: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26777"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5617_2",
    d: "M61.5354 97.9697H36.922C35.3535 97.9697 34.082 99.2412 34.082 100.81C34.082 102.378 35.3535 103.65 36.922 103.65H61.5354C63.1039 103.65 64.3754 102.378 64.3754 100.81C64.3754 99.2412 63.1039 97.9697 61.5354 97.9697Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5618_2",
    d: "M78.5754 110.278H36.922C35.3535 110.278 34.082 111.55 34.082 113.118C34.082 114.687 35.3535 115.958 36.922 115.958H78.5754C80.1439 115.958 81.4154 114.687 81.4154 113.118C81.4154 111.55 80.1439 110.278 78.5754 110.278Z",
    fill: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5617_3",
    d: "M61.5354 123.528H36.922C35.3535 123.528 34.082 124.799 34.082 126.368C34.082 127.936 35.3535 129.208 36.922 129.208H61.5354C63.1039 129.208 64.3754 127.936 64.3754 126.368C64.3754 124.799 63.1039 123.528 61.5354 123.528Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5618_3",
    d: "M78.5754 135.836H36.922C35.3535 135.836 34.082 137.107 34.082 138.676C34.082 140.244 35.3535 141.516 36.922 141.516H78.5754C80.1439 141.516 81.4154 140.244 81.4154 138.676C81.4154 137.107 80.1439 135.836 78.5754 135.836Z",
    fill: "#EEEEEE"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 26779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    filter: "url(#filter1_d_19611_26762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5616",
    d: "M111.707 9.92651H30.2939C27.6797 9.92651 25.5605 12.0457 25.5605 14.6598V43.0598C25.5605 45.674 27.6797 47.7932 30.2939 47.7932H111.707C114.321 47.7932 116.441 45.674 116.441 43.0598V14.6598C116.441 12.0457 114.321 9.92651 111.707 9.92651Z",
    fill: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5617_4",
    d: "M61.5334 20.3403H36.9201C35.3516 20.3403 34.0801 21.6118 34.0801 23.1803C34.0801 24.7488 35.3516 26.0203 36.9201 26.0203H61.5334C63.1019 26.0203 64.3734 24.7488 64.3734 23.1803C64.3734 21.6118 63.1019 20.3403 61.5334 20.3403Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5618_4",
    d: "M78.5734 32.6487H36.9201C35.3516 32.6487 34.0801 33.9202 34.0801 35.4887C34.0801 37.0572 35.3516 38.3287 36.9201 38.3287H78.5734C80.1419 38.3287 81.4134 37.0572 81.4134 35.4887C81.4134 33.9202 80.1419 32.6487 78.5734 32.6487Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19611_26762",
    x: 19.5605,
    y: 49.2065,
    width: 102.881,
    height: 120.867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19611_26762"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19611_26762",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_19611_26762",
    x: 19.5605,
    y: 0.926514,
    width: 102.881,
    height: 49.8667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19611_26762"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19611_26762",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTagsFound);
export default __webpack_public_path__ + "static/media/no-tags-found.ee25d3a35d5260dcaa7386b040e5f960.svg";
export { ForwardRef as ReactComponent };